module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"postCustomViewButton.errorMessage":"There was an error encountered while creating this customView. If everything looks right please contact support so we can help you :)","postCustomViewButton.saveAndView":"Save and View"}}')
  delete Component.options._Ctor
}
